var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtcFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66659 11.1667C6.66659 10.8906 6.89044 10.6667 7.16659 10.6667H12.8333C13.1094 10.6667 13.3333 10.8906 13.3333 11.1667C13.3333 11.4428 13.1094 11.6667 12.8333 11.6667H7.16659C6.89044 11.6667 6.66659 11.4428 6.66659 11.1667Z",
    fill: "#5B5C5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16659 13.1667C6.89044 13.1667 6.66659 13.3906 6.66659 13.6667C6.66659 13.9428 6.89044 14.1667 7.16659 14.1667H11.1666C11.4427 14.1667 11.6666 13.9428 11.6666 13.6667C11.6666 13.3906 11.4427 13.1667 11.1666 13.1667H7.16659Z",
    fill: "#5B5C5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33325 4.16666C3.33325 2.78594 4.45254 1.66666 5.83325 1.66666H10.6311C11.2941 1.66666 11.93 1.93005 12.3988 2.39889L15.9344 5.93442C16.4032 6.40326 16.6666 7.03915 16.6666 7.70219V15.8333C16.6666 17.214 15.5473 18.3333 14.1666 18.3333H5.83325C4.45254 18.3333 3.33325 17.214 3.33325 15.8333V4.16666ZM14.1666 17.3333H5.83325C5.00482 17.3333 4.33325 16.6618 4.33325 15.8333V4.16666C4.33325 3.33823 5.00482 2.66666 5.83325 2.66666H10.6311C10.6708 2.66666 10.7105 2.66824 10.7498 2.67136V5.83332C10.7498 6.79982 11.5333 7.58332 12.4998 7.58332H15.6619C15.665 7.62273 15.6666 7.66238 15.6666 7.70219V15.8333C15.6666 16.6618 14.995 17.3333 14.1666 17.3333ZM15.169 6.58332L11.7498 3.16412V5.83332C11.7498 6.24754 12.0856 6.58332 12.4998 6.58332H15.169Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtcFile);
export default __webpack_public_path__ + "static/media/etcFile.7c1ec4960ab75187bb5319efa583d256.svg";
export { ForwardRef as ReactComponent };